import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Mariana G.',
  city: 'Córdoba'
}, {
  name: 'Luciano R.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina P.',
  city: 'Mendoza'
}, {
  name: 'Paula M.',
  city: 'Rosario'
}, {
  name: 'Sofía L.',
  city: 'La Plata'
}, {
  name: 'Martín S.',
  city: 'Santa Fe'
}, {
  name: 'Valeria T.',
  city: 'Neuquén'
}, {
  name: 'Andrea B.',
  city: 'Mar del Plata'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through purchases
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * RECENT_PURCHASES.length);
        setCurrentPurchase(RECENT_PURCHASES[randomIndex]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-w-xs popup-enter flex items-center gap-3" data-id="element-3">
      <div className="bg-green-100 p-2 rounded-full" data-id="element-4">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-5" />
      </div>
      <div data-id="element-6">
        <p className="text-sm font-bold text-gray-800" data-id="element-7">
          {currentPurchase.name}
        </p>
        <p className="text-xs text-gray-600" data-id="element-8">de {currentPurchase.city}</p>
        <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-9">
          Compró hace unos minutos
        </p>
      </div>
    </div>;
}